
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useInternalAuth } from '@/hooks/useInternalAuth';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';

const Events = () => {
  const isMobile = useIsMobile();
  const { user: internalUser } = useInternalAuth();

  const handleQuickGameSubmit = async () => {
    if (!internalUser) {
      toast.error('You must be logged in to submit a game request');
      return;
    }

    try {
      const { error } = await supabase
        .from('venue_games')
        .insert({
          posted_by: internalUser.id,
          posted_by_role: internalUser.role || 'venue',
          venue_id: internalUser.id,
          game_title: 'Quick Test Game',
          game_date: '2025-09-10',
          game_time: '18:00:00',
          field_location: 'Main Field',
          sport_id: 1,
          scorekeeper_needed: true,
          scorekeeper_points: 75,
          game_code: Math.random().toString(36).substr(2, 6).toUpperCase(),
          status: 'pending',
          game_status: 'pending'
        });

      if (error) throw error;
      toast.success('Game request submitted successfully!');
    } catch (error: any) {
      console.error('Error submitting game:', error);
      toast.error(error.message || 'Failed to submit game request');
    }
  };
  
  return (
    <div className="flex flex-col min-h-screen bg-black w-full">
      {!isMobile && <Header />}
      {isMobile && <MobileHeader />}
      
      <main className="flex-grow mt-24 py-6 md:py-12 px-4 md:px-6 pb-20 md:pb-6 w-full">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-8">Events</h1>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <Card className="bg-gray-800 border-gray-700">
              <CardHeader>
                <CardTitle className="text-white">Upcoming Sports Events</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-400 mb-4">
                  Discover and participate in upcoming sports events, tournaments, and community gatherings.
                </p>
                {internalUser && internalUser.role === 'venue' && (
                  <button
                    onClick={handleQuickGameSubmit}
                    className="bg-sports-green hover:bg-sports-green/90 text-white px-4 py-2 rounded-md"
                  >
                    Quick Submit Test Game
                  </button>
                )}
              </CardContent>
            </Card>

            {internalUser && internalUser.role === 'venue' && (
              <Card className="bg-gray-800 border-gray-700">
                <CardHeader>
                  <CardTitle className="text-white">Venue Game Management</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-400 mb-4">
                    Submit and manage your venue's game requests and bookings.
                  </p>
                  <p className="text-sm text-green-400">
                    ✓ Logged in as: {internalUser.username} (Venue)
                  </p>
                </CardContent>
              </Card>
            )}
          </div>
        </div>
      </main>
      
      {!isMobile && <Footer />}
      {isMobile && <MobileBottomNav />}
    </div>
  );
};

export default Events;
